import { isWindows } from "./getOSDetails.js";

const wrapTextIfNotWindows = wrapper => text => isWindows() ? text : `${wrapper}${text}${wrapper}`;

export default wrapTextIfNotWindows;